import { CoreModule, provideAbpCore, withOptions, ReplaceableComponentsService } from '@abp/ng.core';
import { provideAbpOAuth } from '@abp/ng.oauth';
import { provideSettingManagementConfig } from '@abp/ng.setting-management/config';
import { provideFeatureManagementConfig } from '@abp/ng.feature-management';
import { ThemeSharedModule, provideAbpThemeShared, DEFAULT_VALIDATION_BLUEPRINTS, CUSTOM_ERROR_HANDLERS } from '@abp/ng.theme.shared';
import { VALIDATION_BLUEPRINTS } from '@ngx-validate/core';
import { provideIdentityConfig } from '@abp/ng.identity/config';
import { provideAccountConfig } from '@abp/ng.account/config';
import { registerLocale } from '@abp/ng.core/locale';
import { ThemeBasicModule } from '@abp/ng.theme.basic';
import { provideThemeBasicConfig } from '@abp/ng.theme.basic';
import { NgModule, LOCALE_ID, APP_INITIALIZER, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_ROUTE_PROVIDER } from './route.provider';
import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import { provideHttpClient } from '@angular/common/http';
import { CustomLoginComponent } from './account/login/login.component';
import { CustomRegisterComponent } from './account/register/register.component';
import { CustomConfirmationComponent } from './shared/confirmation/custom-confirmation.component';
import { ToastErrorHandlerService } from './shared/error-handler/toast-error-handler.service';

registerLocaleData(localeTr);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    ThemeSharedModule,
    ThemeBasicModule,
    AppRoutingModule,
    CustomConfirmationComponent,
  ],
  providers: [
    APP_ROUTE_PROVIDER,
    provideAbpCore(
      withOptions({
        environment,
        registerLocaleFn: registerLocale(),
        skipGetAppConfiguration: false,
      }),
    ),
    provideAbpOAuth(),
    provideIdentityConfig(),
    provideSettingManagementConfig(),
    provideFeatureManagementConfig(),
    provideAccountConfig(),
    provideAbpThemeShared(),
    provideThemeBasicConfig(),
    { provide: LOCALE_ID, useValue: 'tr' },
    {
      provide: VALIDATION_BLUEPRINTS,
      useValue: {
        ...DEFAULT_VALIDATION_BLUEPRINTS,
        required: 'Bu alan zorunludur.',
        minlength: 'Bu alan en az {{ requiredLength }} karakter olmalidir.',
        maxlength: 'Bu alan en fazla {{ requiredLength }} karakter olabilir.',
        email: 'Gecerli bir e-posta adresi girin.',
        pattern: 'Bu alan gecerli bir formatta degil.',
        min: 'Bu alan en az {{ min }} olmalidir.',
        max: 'Bu alan en fazla {{ max }} olabilir.',
      },
    },
    provideHttpClient(),
    {
      provide: CUSTOM_ERROR_HANDLERS,
      useExisting: ToastErrorHandlerService,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configureAccountComponents,
      deps: [Injector],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function configureAccountComponents(injector: Injector) {
  return () => {
    const replaceableComponents = injector.get(ReplaceableComponentsService);

    replaceableComponents.add({
      key: 'Account.LoginComponent',
      component: CustomLoginComponent,
    });

    replaceableComponents.add({
      key: 'Account.RegisterComponent',
      component: CustomRegisterComponent,
    });
  };
}
